export default "__VITE_ASSET__DkeDS5iN__";